import { useEffect, useState } from 'react';
import { googleSheetsApi } from '../api/googleSheets';

let cache = null;
let inflight = null;

export function __resetGoogleSheetsConfigCache() {
  cache = null;
  inflight = null;
}

export function useGoogleSheetsConfig() {
  const [config, setConfig] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let active = true;

    if (cache) {
      setConfig(cache);
      setLoading(false);
      return undefined;
    }

    inflight =
      inflight ||
      googleSheetsApi
        .getConfig()
        .then((c) => {
          cache = { enabled: !!(c && c.enabled), spreadsheetUrl: (c && c.spreadsheetUrl) || null };
          return cache;
        })
        .catch(() => {
          cache = { enabled: false, spreadsheetUrl: null };
          return cache;
        });

    inflight.then((c) => {
      if (active) {
        setConfig(c);
        setLoading(false);
      }
    });

    return () => {
      active = false;
    };
  }, []);

  return {
    enabled: !!(config && config.enabled),
    spreadsheetUrl: (config && config.spreadsheetUrl) || null,
    loading,
  };
}
